import { useNavigate } from "react-router-dom";

const faqItems = [
  {
    id: 1,
    name: "Anna K.",
    username: "@anna_krakow",
    content:
      "Czy Kakobuy działa w Polsce? Tak — Kakobuy obsługuje zamówienia do Polski z pełną obsługą wysyłki i śledzenia przesyłek. Wystarczy wybrać Polskę jako kraj docelowy przy składaniu zamówienia.",
    bgColor: "bg-accent-100",
    textColor: "text-accent-800",
  },
  {
    id: 2,
    name: "Marek W.",
    username: "@marek_warszawa",
    content:
      "Jak długo trwa dostawa? Standardowa dostawa do Polski trwa zazwyczaj od 10 do 20 dni roboczych, w zależności od wybranej metody wysyłki i lokalizacji sprzedawcy.",
    bgColor: "bg-primary-100",
    textColor: "text-primary-800",
  },
  {
    id: 3,
    name: "Kasia N.",
    username: "@kasia_poznan",
    content:
      "Czy Kakobuy jest bezpieczny? Kakobuy współpracuje ze sprawdzonymi sprzedawcami i oferuje ochronę płatności. Kupuj wyłącznie od zweryfikowanych dostawców i sprawdzaj opinie innych użytkowników.",
    bgColor: "bg-secondary-100",
    textColor: "text-secondary-800",
  },
  {
    id: 4,
    name: "Piotr Z.",
    username: "@piotr_gdansk",
    content:
      "Jak znaleźć najlepszy Kakobuy Spreadsheet? Najlepszy arkusz Kakobuy Spreadsheet znajdziesz na kaspreadsheet.com. Zawiera on kompletny zbiór zweryfikowanych linków do produktów we wszystkich kategoriach.",
    bgColor: "bg-accent-100",
    textColor: "text-accent-800",
  },
  {
    id: 5,
    name: "Magda S.",
    username: "@magda_wroclaw",
    content:
      "Czy trzeba płacić cło? Przy wartości zamówienia powyżej 150 EUR mogą obowiązywać opłaty celne. Przed większym zamówieniem warto sprawdzić aktualne przepisy celne obowiązujące w Polsce.",
    bgColor: "bg-primary-100",
    textColor: "text-primary-800",
  },
  {
    id: 6,
    name: "Tomek L.",
    username: "@tomek_lodz",
    content:
      "Jakie metody płatności obsługuje Kakobuy? Kakobuy akceptuje karty kredytowe, PayPal oraz przelewy bankowe, co daje polskim użytkownikom elastyczność w wyborze dogodnej metody płatności.",
    bgColor: "bg-secondary-100",
    textColor: "text-secondary-800",
  },
];

export default function FAQSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block px-4 py-1.5 bg-background-200 rounded-full text-xs font-semibold text-foreground-700 mb-4 whitespace-nowrap">
            Opinie i FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            Najczęściej Zadawane
            <br />
            Pytania
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 md:gap-6">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="break-inside-avoid mb-5 md:mb-6 bg-background-50 rounded-2xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 rounded-full ${item.bgColor} flex items-center justify-center flex-shrink-0`}>
                  <span className={`text-sm font-bold ${item.textColor}`}>
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.username}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="/artykul/co-to-jest-kakobuy-spreadsheet"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              navigate("/artykul/co-to-jest-kakobuy-spreadsheet");
            }}
          >
            Przeczytaj pełny poradnik Kakobuy Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}